<template>
    <bottom-sheet
            title="優惠折扣"
            @onCancel="onCancel"
            @onConfirm="onConfirm"
            @onClose="onClose">
        <div class="coupon">
            <div class="input">
                <input type="search" v-model="code" placeholder="請輸入折扣代碼">
                <div class="button" :class="{'green': code.length}" @click="exchange">兌換</div>
            </div>
            <div class="error">
                <div class="msg">
                    {{ errMsg || '' }}
                </div>
            </div>
            <div class="list">
                <label class="item" v-for="coupon in coupons" :key="coupon.id">
                    <div class="title">{{ coupon.title }}</div>
                    <div class="button">
                        <div class="price">- $ {{ coupon.value }}</div>
                        <p-radio name="coupon" :value="coupon.id" v-model="selected" p-type="checkbox"/>
                    </div>
                </label>
            </div>
        </div>
    </bottom-sheet>
</template>

<script>
    import BottomSheet from '../BottomSheet';
    import PRadio from '../RadioButton';
    import { mapActions, mapGetters } from 'vuex';

    export default {
        name: 'SetCoupon',
        components: {
            'bottom-sheet': BottomSheet,
            'p-radio': PRadio,
        },
        props: {
            coupon: {
                default: null
            }
        },
        data() {
            return {
                code: '',
                errMsg: '',
                selected: 0,
            }
        },
        computed: {
            ...mapGetters(['coupons'])
        },
        methods: {
            onCancel() {
                this.$emit('onCancel');
            },
            onConfirm() {
                if ( ! this.selected) {
                    this.$emit('onDone', null);
                    return ;
                }

                let coupon = this.coupons.find(val => val.id == this.selected);
                this.$emit('onDone', coupon);
            },
            onClose() {
                this.$emit('onCancel');
            },
            exchange() {
                if ( ! this.code.length) {
                    return ;
                }

                this.addCoupon({code: this.code}).then(coupon => {
                    this.selected = coupon.id;
                }).catch(err => {
                   this.errMsg = err.response.data.message;
                });
            },
            ...mapActions(['addCoupon'])
        },
        mounted() {
            if (this.coupon) {
                this.selected = this.coupon.id;
            }
        }
    };
</script>

<style lang="scss" scoped>
    .input {
        display: flex;

        input {
            width: 100%;
            border: 1px solid rgba(221,221,221,1);
            border-radius: 4px;
            font-size: 14px;
            line-height: 20px;
            margin-right: 10px;
            padding: 10px;
        }

        .button {
            display: flex;
            align-items: center;
            justify-content: center;
            height: 40px;
            width: 48px;
            border: 1px solid rgba(221,221,221,1);
            border-radius: 4px;
            color: rgba(155,155,155,1);
            font-size: 14px;
            line-height: 20px;

            &.green {
                color: rgba(51,153,51,1);
                border: 1px solid rgba(51,153,51,1);
            }
        }
    }

    .list {
        min-height: 50px;
        max-height: 50%;
        overflow-y: auto;

        .item {
            display: flex;
            justify-content: space-between;
            padding: 10px;
            border: 1px solid rgba(221,221,221,1);
            border-radius: 4px;
            margin-bottom: 10px;

            .title {
                color: rgba(0,0,0,1);
                font-size: 14px;
                line-height: 20px;
            }

            .button {
                display: flex;
                justify-content: space-between;
                color: rgba(155,155,155,1);
                font-size: 14px;
                line-height: 20px;
                text-align: right;

                .price {
                    margin-right: 15px;
                }
            }
        }
    }

    .error {
        padding: 3px 10px;

        .msg {
            height: 20px;
            color: rgba(244,67,54,1);
            font-size: 14px;
            line-height: 20px;
            text-align: left;
        }
    }

    input[type=radio]{
        &:checked {
            &.label {
                background-position : 0 -22px;
            }
        }
    }
</style>
